import axios from "axios";
import instance from "../ApiConfig";
import { ApiEndPoints } from "../ApiEndPoints";

export const createRecord = async (data: object, url) => {
  try {
    const result = await instance({
      url: url,
      method: "POST",
      data,
    });
    // return result;
    return result.data;
  } catch (error) {

    
    throw error;
  }
};

export const sendEmail = async (data: object, url) => {
  try {
    const result = await instance({
      url: url,
      method: "POST",
      data,
    });
    // return result;
    return result.data;
  } catch (error) {
    throw error;
  }
}

export const sendSms = async (data: object, url) => {
  try {
    const result = await instance({
      url: url,
      method: "POST",
      data,
    });
    // return result;
    return result.data;
  } catch (error) {
    throw error;
  }
}

export const updateCardRecord = async (data: object, url) => {
  try {
    const result = await instance({
      url: url,
      method: "PUT",
      data,
    });
    // return result;
    return result.data;
  } catch (error) {
    throw error;
  }
};


export const updateRecord = async (data: object, id: number, url) => {
  try {
    const result = await instance({
      url: url + `/${id}`,
      method: "PUT",
      data,
    });
    // return result;
    return result.data;
  } catch (error) {
    throw error;
  }
};

export const updateRecordData = async (data: object,  url) => {
  try {
    const result = await instance({
      url: url ,
      method: "PUT",
      data,
    });
    // return result;
    return result.data;
  } catch (error) {
    throw error;
  }
};

export const deleteRecord = async (id, url) => {
  try {
    const result = await instance({
      url: url + `/${id}`,
      method: "DELETE",
    });
    // return result;
    return result.data;
  } catch (error) {
    throw error;
  }
};



export const getRecord = async (id, url) => {
  try {
    const result = await instance({
      url: url + `/${id}`,
      method: "GET",
    });
    // return result;
    return result.data;
  } catch (error) {
    throw error;
  }
};

export const fetchList = async (url) => {
  try {
    const result = await instance({
      url: url,
      method: "GET",
    });
    // return result;
    return result.data;
  } catch (error) {
    throw error;
  }
};

export const fetchExternalList = async (url) => {
  try {
    const result = await axios.get(url);
    return result.data;
  } catch (error) {
    throw error;
  }
};
